import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { IMarkupService } from "../IMarkupService";
import { MarkupCriteria } from "../../model/core/MarkupCriteria";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class MarkupPromiseService implements IMarkupService {
  abstract retrieveMarkupForCriteria(
    criteria: MarkupCriteria,
  ): Promise<CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl>;

  public getMarkupTypeLabel(markupType: CubiqTS.MarkUpType) {
    let markupTypeLabel = null;
    switch (markupType) {
      case CubiqTS.MarkUpType.Percentage:
        markupTypeLabel = "%";
        break;
      case CubiqTS.MarkUpType.UsdPerMillion:
        markupTypeLabel = "$/m";
        break;
      case CubiqTS.MarkUpType.Pips:
        markupTypeLabel = "Pips";
        break;
      default:
        break;
    }

    return markupTypeLabel;
  }

  public getMarkupPrecisionByType(
    pair: CubiqTS.CurrencyPairImpl,
    isInvert: boolean,
    markupType: CubiqTS.MarkUpType,
  ): number | null {
    let precision = null;
    if (markupType != null) {
      switch (markupType) {
        case CubiqTS.MarkUpType.Percentage:
          precision = 4;
          break;
        case CubiqTS.MarkUpType.UsdPerMillion:
          precision = 2;
          break;
        case CubiqTS.MarkUpType.Pips:
          if (pair instanceof CubiqTS.CurrencyPairImpl) {
            precision = Math.max(
              0,
              this.getMarkupPrecision(pair, isInvert) - this.getSpotPrecision(pair, isInvert),
            );
          } else {
            precision = null;
          }
          break;
      }
    }
    logger.out.info(`${this.constructor.name}.getMarkupPrecisionByType() precision: ${precision}`);
    return precision;
  }

  private getMarkupPrecision(pair: CubiqTS.CurrencyPairImpl, isInvert: boolean): number | null {
    let precision = null;
    if (pair instanceof CubiqTS.CurrencyPairImpl) {
      if (isInvert) {
        precision = pair.markupSptInvDecimals;
      } else {
        precision = pair.markupSptDecimals;
      }
    }
    let result =
      precision != null && typeof precision === "number" && precision >= 0 ? precision : null;
    logger.out.info(`${this.constructor.name}.getMarkupPrecisionByType() precision: ${result}`);
    return result;
  }

  public getSpotPrecision(pair: CubiqTS.CurrencyPairImpl, isInvert: boolean): number | null {
    let precision = null;
    if (pair instanceof CubiqTS.CurrencyPairImpl) {
      if (isInvert) {
        precision = pair.spotInvertDecimalsQty;
      } else {
        precision = pair.rateDecimalsQty;
      }
    }
    let result =
      precision != null && typeof precision === "number" && precision >= 0 ? precision : null;
    logger.out.info(`${this.constructor.name}.getMarkupPrecision() -> Precision: ${result}`);
    return result;
  }
}
